export const agency = {
  activities: {
    activities: '活动',
    upcomingRenewals: '即将续订',
    subscriptionActivities: '订阅活动',
    upcomingDowngradeRequests: '即将降级请求',
    serialNumber: '序号',
    email: '电子邮件',
    phoneNumber: '电话号码',
    currentPlan: '当前计划',
    price: '价格',
    daysLeft: '剩余天数',
    noDataFound: {
      upcomingDowngrades: '即将降级',
      noUpcomingDowngradesFoundYet: '尚未找到即将降级的信息！',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: '客户即将续订',
      subscriptionActivities: '订阅活动',
      upcomingDowngradeRequestsOfCustomers: '客户即将降级请求',
      serialNumber: '序列号',
      customerEmail: '客户电子邮件',
      customerPhoneNumber: '客户电话号码',
      currentPlanOfCustomer: '客户当前计划',
      currentPlanPrice: '客户当前计划价格',
      daysLeft: '客户当前计划剩余天数'
    },
  },
  configuration: {
    configurationsHeader: '配置',
    emailHeader: '电子邮件',
    razorPayHeader: 'RazorPay',
    invoiceDetailsHeader: '发票详细信息',
    stripeHeader: '条纹',
    retentionPolicyHeader: '保留政策',
    zohoHeader: 'Zoho',
    appTooltip: {
      integrateYourEmailProviderDetails: '集成您的电子邮件提供商详细信息，以无缝发送客户电子邮件。',
      enterYourRazorPayAccountDetails: '输入您的RazorPay账户详细信息，以实现无缝的客户付款处理。',
      enterYourStripeAccountDetails: '输入您的Stripe账户详细信息，以实现无缝的客户付款处理。',
      enterYourCompanyDetails: '输入您的公司详细信息，以进行准确的发票和专业的发票生成。',
      retentionPolicyDescription: '保留政策旨在管理系统内数据的生命周期。',
      enterYourZohoKeys: '输入您的Zoho客户端ID和Zoho客户端秘密密钥，以实现成功的集成。',
      enterYourGoogleKeys: '为了成功的集成，请输入您的Google客户端ID和Google客户端秘钥。'
    },
    email: {
      testEmail: '测试邮件',
      addEmailIntegrationsDetails: '添加电子邮件集成详细信息',
      integrationDescription: '要集成您的电子邮件提供商详细信息，请提供您的电子邮件提供商信息。' +
        '所有通信电子邮件将使用此电子邮件地址发送给您的客户，确保重要通知和更新的一致且可靠的传递。',
      awsRegion: 'AWS区域',
      awsAccessKeyId: 'AWS访问密钥ID',
      awsSecretAccessKey: 'AWS秘密访问密钥',
      reset: '重置',
      addDetails: '添加详细信息',
      updateDetails: '更新详细信息',
      fromEmail: '发件人电子邮件',
      appTooltip: {
        TOOLTIP_AWS_REGION: '输入您的AWS区域。该区域确定资源的物理位置，影响数据延迟和法规遵从等因素。',
        TOOLTIP_AWS_ACCESS_KEY_ID: '输入您的AWS访问密钥ID。此密钥唯一标识您的AWS账户，用于安全身份验证和访问AWS服务。',
        TOOLTIP_AWS_SECRET_ACCESS_KEY_ID: '输入您的AWS秘密访问密钥。此密钥用于安全身份验证和访问AWS服务。',
        fromEmail: '用于发送所有平台电子邮件的电子邮件（例如线索电子邮件、帐户警报等）'
      },
      placeholders: {
        enterAwsRegion: '输入AWS区域',
        enterAwsAccessKeyId: '输入AWS访问密钥ID',
        enterAwsSecretAccessKey: '输入AWS秘密访问密钥',
        enterFromEmail: '输入电子邮件地址'
      },
      modal: {
        deleteEmailIntegration: '删除电子邮件集成',
        wantToDeleteEmailIntegration: '您确定要删除此电子邮件集成吗？',
      }
    },
    facebook: {
      addFacebookIntegrationsDetails: '添加Facebook集成详细信息',
      integrateYourEmailProviderDetails: '集成您的电子邮件提供商详细信息。所有电子邮件将使用此电子邮件发送给您的客户',
      facebookAppId: 'Facebook应用程序ID',
      facebookSecretAccessKey: 'Facebook秘密访问密钥',
      reset: '重置',
      cancel: '取消',
      addDetails: '添加详细信息',
      updateDetails: '更新详细信息',
      delete: '删除',
      testEmail: '测试邮件',
      modal: {
        deleteFacebookIntegration: '删除Facebook集成',
        wantToDeleteFacebookIntegration: '您确定要删除此电子邮件集成吗？'
      },
      placeholders: {
        enterFacebookAccessKeyId: '输入Facebook秘密访问密钥',
        enterFacebookAppId: '输入Facebook应用程序ID'
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES: '根据您希望在机器人用户发送实时聊天请求后立即出现在聊天窗口上的方式自定义消息',
      }
    },
    invoiceDetails: {
      addInvoiceDetails: '添加发票详细信息',
      invoicesDescription: '为您的客户生成发票，请提供您的公司详细信息，包括公司名称，' +
        '地址，联系信息以及准确发票所需的任何其他相关信息。' +
        '此信息将用于代表您的公司为每笔交易创建专业的发票。',
      companyName: '公司名称',
      country: '国家',
      selectCountry: '选择国家',
      stateOrRegion: '州/地区',
      streetAddress: '街道地址',
      gstin: 'GSTIN',
      postalCode: '邮政编码',
      addDetails: '添加详细信息',
      updateDetails: '更新详细信息',
      reset: '重置',
      delete: '删除',
      loadMore: '加载更多',
      time: '时间',
      phoneNumber: '电话号码',
      email: '电子邮件',
      status: '状态',
      message: '消息',
      response: '响应',
      placeOfSupply: '供应地点',
      placeholders: {
        enterYourCompanyName: '输入您的公司名称',
        enterYourStateOrRegion: '输入您的州/地区',
        enterYourStreetAddress: '输入您的街道地址',
        enterYourGstin: '输入您的GSTIN',
        enterPostalCode: '输入邮政编码',
        enterPlaceOfSupply: '输入供货地点'
      },
      modal: {
        deleteEmailIntegration: '删除电子邮件集成',
        wantToDeleteEmailIntegration: '您确定要删除此电子邮件集成吗？',
      },
      appTooltip: {
        TOOLTIP_COMPANY_NAME:
          '输入您的公司名称。此信息将用于发票中的标识和品牌目的。',
        TOOLTIP_COUNTRY: '选择您的国家。此信息将用于发票中的标识和品牌目的。',
        TOOLTIP_STATE: '输入您的州。此信息将用于发票中的标识和品牌目的。',
        TOOLTIP_STREET_ADDRESS: '输入您的街道地址。此信息将用于发票中的标识和品牌目的。',
        TOOLTIP_GSTIN: '输入您的GSTIN。此信息将用于发票中的标识和品牌目的。',
        TOOLTIP_POSTAL_CODE: '输入您的邮政编码。此信息将用于发票中的标识和品牌目的。',
        TOOLTIP_PLACE_OF_SUPPLY: '输入您的供货地点。此信息将用于发票中的标识和品牌目的。',
      }
    },
    razorPay: {
      addRazorPayIntegrationsDetails: '添加RAZORPAY集成详细信息',
      integrationDescription: '要集成您的RazorPay账户详细信息，请提供您的RazorPay账户信息。' +
        '所有客户付款将通过您的RazorPay账户进行无缝交易处理',
      razorPayAccessKeyId: 'RAZORPAY访问密钥ID',
      razorPaySecretAccessKey: 'RAZORPAY秘密访问密钥',
      reset: '重置',
      addDetails: '添加详细信息',
      updateDetails: '更新详细信息',
      loadMore: '加载更多',
      time: '时间',
      phoneNumber: '电话号码',
      email: '电子邮件',
      status: '状态',
      message: '消息',
      response: '响应',
      placeholders: {
        enterRazorPayAccessKeyId: '输入Razorpay访问密钥ID',
        enterRazorPaySecretAccessKey: '输入Razorpay秘密访问密钥',
        enterRazorPayAccessId: '输入RazorPay访问ID',
      },
      appTooltip: {
        TOOLTIP_RAZORPAY_ID: '输入您的Razorpay访问密钥ID。此密钥唯一标识您与Razorpay的集成，是安全支付交易所需的。',
        TOOLTIP_RAZORPAY_SECRET_KEY: '输入您的Razorpay秘密访问密钥。此密钥对于应用程序与Razorpay之间的安全通信至关重要，实现无缝交易处理和支付管理。',
      },
      modal: {
        deleteRazorPayIntegration: '删除电子邮件集成',
        wantToDeleteThisIntegrtion: '您确定要删除此电子邮件集成吗？',
      }
    },

    stripe: {
      addStripeIntegrationDetails: '添加Stripe集成详细信息',
      integrationDescription: '为了集成您的Stripe帐户详细信息，请提供您的Stripe帐户信息。' +
        ' 所有客户付款将通过您的Stripe帐户进行处理，以实现无缝交易',
      stripeSecretAccessKey: 'Stripe秘密访问密钥',
      stripePublicKey: 'Stripe公钥',
      reset: '重置',
      addDetails: '添加详情',
      updateDetails: '更新详情',
      cancel: '取消',
      loadMore: '加载更多',
      time: '时间',
      phoneNumber: '电话号码',
      email: '电子邮件',
      status: '状态',
      message: '消息',
      response: '响应',
      placeholders: {
        enterStripeSecretAccessKey: '输入Stripe秘密访问密钥',
        enterStripePublicKey: '输入Stripe公钥',
      },
      appTooltip: {
        TOOLTIP_STRIPE_SECRET_KEY: '输入您的Stripe秘密访问密钥。此密钥用于安全地验证您与Stripe的集成，并且对于处理客户付款是必要的。',
        TOOLTIP_PUBLIC_KEY: '输入您的Stripe公钥。此密钥用于安全地验证您与Stripe的集成（在客户端上），对于处理客户付款是必要的。',
      },
      modal: {
        deleteStripeIntegration: '删除Stripe集成',
        wantToDeleteStripeIntegration: '您确定要删除此Stripe集成吗？'
      }
    },
    retentionPolicy: {
      retentionPolicy: '保留政策',
      retentionPolicyDescription: '保留政策旨在管理系统内数据的生命周期，指定数据在被系统性地和安全地移除之前应保留多长时间。此政策旨在确保符合数据保护法规，优化存储资源，并以高效有序的方式管理数据。',
      apiLogs: 'API日志保留天数',
      selectApiLogs: '选择API日志保留天数',
      update: '更新',
      save: '保存',
      day: '天',
      days: '天',
      placeholders: {
        enterNumberOfDays: '输入天数'
      },
    },
    zoho: {
      addZohoIntegrationDetails: '添加Zoho集成详细信息',
      zohoDescription: `轻松连接您的聊天机器人平台与Zoho CRM、Zoho Projects和Zoho Desk。这将允许用户自动传输其聊天机器人捕获的潜在客户数据，并在相应的Zoho模块中创建任务。为了启动成功的集成，请提供您的Zoho客户端ID和Zoho客户端秘密密钥。`,
      zohoClientId: 'Zoho客户端ID',
      zohoClientSecret: 'Zoho客户端秘密',
      zohoCrmExtensionUrl: 'Zoho CRM扩展URL',
      add: '添加',
      update: '更新',
      placeholders: {
        enterZohoClientId: '输入您的Zoho客户端ID',
        enterZohoClientSecret: '输入您的Zoho客户端秘密',
        enterZohoCrmExtensionUrl: '输入您的Zoho CRM扩展URL'
      }
    },
    google: {
      addGoogleIntegrationDetails: '添加Google集成详细信息',
      googleDescription: `轻松连接您的Final_Brand与Google任务、Google联系人、Google日历、Google表格和Google分析。这使用户能够通过将聊天机器人捕获的数据传输到首选的Google应用程序来设置工作流自动化。为了启动成功的集成，请提供您的Google客户端ID和Google客户端秘钥。`,
      googleClientId: 'Google客户端ID',
      googleClientSecret: 'Google客户端秘钥',
      add: '添加',
      update: '更新',
      placeholders: {
        enterGoogleClientId: '输入您的Google客户端ID',
        enterGoogleClientSecret: '输入您的Google客户端秘钥',
      }
    }

  },
  customer: {
    manageCustomers: '管理客户',
    addNewCustomers: '添加新客户',
    ensureYouHaveAddedAllYourCustomersHere: '确保您已在此处添加了所有客户',
    customerName: '客户名称',
    nameIsRequired: '名称是必需的',
    emailId: '电子邮件ID',
    enterAValidEmail: '请输入有效的电子邮件',
    createPassword: '创建密码',
    enterAStrongPassword: '输入强密码',
    confirmPassword: '确认密码',
    cancel: '取消',
    customer: '客户',
    searchByNameOrEmail: '按姓名或电子邮件搜索',
    filters: '筛选器',
    allCustomers: '所有客户',
    paidCustomers: '付费客户',
    freeCustomers: '免费客户',
    messageAddOnCustomers: '消息附加客户',
    botWhiteLabelCustomers: '机器人白标客户',
    sortBy: '排序方式',
    sortByFrequency: '按频率排序',
    all: '全部',
    joinedDate: '加入日期',
    plan: '计划',
    lastLogin: '最后登录',
    email: '电子邮件',
    nextDue: '下次到期',
    frequency: '频率',
    clearAll: '清除所有',
    apply: '应用',
    messageConsumed: '消息已消费',
    addCustomer: '添加客户',
    serialNumber: '序号',
    name: '姓名',
    contact: '联系方式',
    limit: '限制',
    location: '位置',
    actions: '操作',
    joinedOn: '加入日期',
    typeOfCustomer: '客户类型',
    exceptWhatsapp: '（除Whatsapp外）',
    exceptWA: '（除WA外）',
    wa: '（WA）',
    loadMore: '加载更多',
    conversationsWhatsapp: '对话（Whatsapp）',
    appTooltip: {
      enterCustomerEmail: '输入客户电子邮件',
      enterCustomerPassword: '输入客户密码',
      enterCustomerConfirmPassword: '输入客户确认密码',
      enterCustomerName: '输入客户名称',
    },
    placeholders: {
      enterCustomerEmail: '输入客户电子邮件',
      searchByNameOrEmail: '按姓名或电子邮件搜索',
      enterPassword: '输入密码',
      enterCustomerName: '输入客户名称',
    }
  },
  dashboard: {
    dashboard: '仪表板',
    overview: '概览',
    totalCustomers: '总客户数',
    paidCustomers: '付费客户',
    freeCustomers: '免费客户',
    thisWeeksSignUp: '本周注册',
    todaysSignUp: '今天的注册',
    totalEarnings: '总收入',
    nA: '不适用',
    customerName: '客户名称',
    nameIsRequired: '名称是必需的',
    emailId: '电子邮件ID',
    enterAValidEmail: '请输入有效的电子邮件',
    editCustomer: '编辑客户',
    recentSignUps: '最近的注册',
    serialNumber: '序号',
    name: '姓名',
    email: '电子邮件',
    contact: '联系方式',
    plan: '计划',
    limit: '限制',
    location: '位置',
    lastLogin: '最后登录',
    joinedOn: '加入日期',
    actions: '操作',
    exceptWhatsapp: '（除Whatsapp外）',
    messageConsumed: '消息已消费',
    conversationsWhatsapp: '对话（Whatsapp）',
    placeholders: {
      enterCustomerName: '输入客户名称',
      enterCustomerEmail: '输入客户电子邮件',
    },
    modal: {
      deleteCustomer: '删除客户',
      areYouSure: '您确定要删除此客户吗？'
    }
  },
  downgradeRequests: {
    activites: '活动',
    upcomingRenewals: '即将续订',
    subscriptionActivities: '订阅活动',
    upcomingDonwgradeRequests: '即将降级请求',
    serialNumber: '序号',
    email: '电子邮件',
    phoneNumber: '电话号码',
    currentPlan: '当前计划',
    requestedOn: '请求日期',
    downgradeOn: '降级日期',
    nA: '不适用',
    commaMonthly: '，每月',
    commaYearly: '，每年',
    noDataFound: {
      downgradeRequests: '降级请求',
      noDowngradeRequestFound: '尚未找到降级请求！',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: '即将续订的客户',
      subscriptionActivities: '订阅活动',
      upcomingDowngradeOfCustomers: '即将降级的客户请求',
      serialNumber: '序列号',
      customerEmail: '客户电子邮件',
      customerPhoneNumber: '客户电话号码',
      currentPlanOfCustomer: '客户的当前计划',
      currentPlanPrice: '客户当前计划的价格',
    }
  },
  emailIntegration: {
    emailIntegration: '电子邮件集成',
    addEmailIntegrationDetails: '添加电子邮件集成详细信息',
    integrateYourEmailProviderDetails: '集成您的电子邮件提供商详细信息。所有电子邮件将使用此电子邮件发送给您的客户',
    awsRegion: 'AWS区域',
    awsRegionIsRequired: 'AWS区域是必需的',
    awsAccessKeyId: 'AWS访问密钥ID',
    awsAccessKeyIdIsRequired: 'AWS访问密钥ID是必需的',
    awsSecretAccessKey: 'AWS秘密访问密钥',
    awsSecretAccessKeyIsRequired: 'AWS秘密访问密钥是必需的',
    cancel: '取消',
    test: '测试',
    action: '操作',
    testEmail: '测试电子邮件',
    addDetails: '添加详细信息',
    updateDetails: '更新详细信息',
    saveDetails: '保存详细信息',
    placeholders: {
      enterAwsRegion: '输入AWS区域',
      enterAwsAccessKeyId: '输入AWS访问密钥ID',
      enterAwsSecretAccessKey: '输入AWS秘密访问密钥',
    },
    modal: {
      deleteEmailIntegration: '删除电子邮件集成',
      areYouSure: '您确定要删除此电子邮件集成吗？',
    },
    noDataFound: {
      emailIntegration: '电子邮件集成',
      noEmailIntegrationFoundYet: '尚未找到电子邮件集成！'
    }
  },
  subscription: {
    activities: '活动',
    upcomingRenewals: '即将续订',
    subscriptionActivities: '订阅活动',
    upcomingDonwgradeRequests: '即将降级请求',
    filters: '筛选器',
    manageActivities: '管理活动',
    sortBy: '排序方式',
    all: '全部',
    upgrades: '升级',
    downgrades: '降级',
    renewals: '续订',
    serialNumber: '序号',
    email: '电子邮件',
    phoneNumber: '电话号码',
    previousPlan: '先前计划',
    newPlan: '新计划',
    description: '描述',
    date: '日期',
    nA: '无',
    upgraded: '已升级',
    commaYearly: '，年度',
    commaMonthly: '，月度',
    noDataFound: {
      noSubscriptionActivitiesFoundYet: '尚未找到订阅活动！',
      subscriptionsActivities: '订阅活动',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: '客户即将续订',
      subscriptionActivities: '订阅活动',
      upcomingDowngradeRequests: '客户即将降级请求',
      serialNumber: '序号',
      customerEmail: '客户电子邮件',
      customerPhoneNumber: '客户电话号码',
      previousPlan: '客户先前计划',
      newPlan: '客户新计划',
      description: '计划描述',
      typeOfPayment: '付款类型',
    }
  },
  feedbacks: {
    feedbacks: '反馈',
    serialNumber: '序号',
    customer: '客户',
    type: '类型',
    rating: '评分',
    reason: '原因',
    description: '描述',
    createdAt: '创建于',
    nA: '无',
    loadMore: '加载更多',
    dataNotFound: {
      accountAndBotDeletionFeedbacks: '账户和机器人删除反馈',
      noFeedbacksFoundYet: '尚未找到反馈！',
    },
    appTooltip: {
      serialNumber: '序号',
      customerEmail: '客户电子邮件',
      feedbackForBotOrAccountDeletion: '（机器人/账户删除）的反馈',
      customerRating: '客户评分',
      customerReason: '客户原因',
      feedbackCreatedAt: '反馈创建于',
      customerFeedback: '客户反馈',
    }
  },
  emailActivity: {
    emailActivityHeading: '电子邮件活动',
    heading: '您的电子邮件活动',
    subHeading: '根机构的电子邮件日志',
    searchLabel: '按客户名称筛选',
    customerName: '客户名称',
    emailType: '电子邮件类型',
    fromEmail: '发件人电子邮件',
    toEmail: '收件人电子邮件',
    createdAt: '创建于',
    action: '操作',
    loadMore: '加载更多',
    noEmailActivityYet: '尚未找到电子邮件活动！',
  }
};
